export const environment = {
  production: true,
  securedDomains: ['localhost:8081', 'int.cwidentify.com'],
  platformApi: 'https://int.cwidentify.com',
  cognito: {
    region: 'us-east-1',
    identityPoolId: 'us-east-1:91f1566f-b615-4534-b90e-ce407a584d0b',
    userPoolId: 'us-east-1_EuUxCKRIJ',
    clientId: '4ga64gp9u8qbsfju3sf8mu3fe8',
    idp_endpoint: 'cognito-idp.us-east-1.amazonaws.com/us-east-1_EuUxCKRIJ',
    cognito_identity_endpoint: ''
  },
  environmentNotificationLabel: 'INT',
  environmentNotificationDesc: 'This is an integration environment and does not have production security controls. Please do not use real world information.',
  generateReportOnClient: undefined,
  sessionTimeoutMinutes: 15,
  connectwiseOrigin: 'connectwise',
  vulnerabilityScanner: 'https://vulnerability.netalytics.tech/agents/VulnerabilityScanner.exe',
  vulnerabilityScannerMD5: '3b363345190c863dfa642873e7e94525',
  cognitoJwtIssuer: 'https://cognito-idp.us-east-1.amazonaws.com/us-east-1_EuUxCKRIJ',
  cwJwtIssuer: 'https://sts.connectwisedev.com',
  cwSSO: {
    authority: 'https://sts.connectwisedev.com',
    clientId: 'identify.assessments.ui',
    redirectUri: 'https://int.cwidentify.com/public/ssoLogin',
    silentRedirectUri: 'https://int.cwidentify.com/silent-refresh.html',
    popupRedirectUri: 'https://int.cwidentify.com/signin-popup.html'
  },
  sbamSSO: {
    authority: 'https://sts.connectwisedev.com',
    clientId: 'identify.assessments.ui',
    redirectUri: 'https://int.cwidentify.com/public/ssoLogin',
    silentRedirectUri: 'https://int.cwidentify.com/silent-refresh.html'
  },
  sentry: {
    dsn: 'https://20a30710dc0f44b882c1a8f68171a176@sentry.io/1484883',
    environment: 'int-na'
  },
  trialRegistrationUrl: 'https://qa-www-mk.connectwise.com/resources/trial/identify',
  allowDirectRegistration: true
};
